import {gql} from "@apollo/client";

export const GET_STATUS = gql`
	query Status {
    status {
        eventQueueMessageCount,
        jobItemQueueMessageCount
    }
}
`;
